import { useGetOrderDetails } from '@/hooks/order/useGetOrderDetails';
import { useGoBack } from '@/hooks/useGoBack';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { orderDetailResponseToHeaderUi } from '../mapper';
import { initialState } from './HeaderUi';

export function useHeaderViewController() {
  const orderDetailId = useParams().orderDetailId ?? '';
  const { data } = useGetOrderDetails(orderDetailId);
  const [uiState, setUiState] = useImmer(initialState);
  const goBackHook = useGoBack();

  useEffect(() => {
    if (!data) return;
    setUiState(orderDetailResponseToHeaderUi(data));
  }, [data]);

  const handleReturnClick = () => goBackHook.goBack();

  return {
    uiState,
    actions: {
      handleReturnClick,
    },
  };
}
